import { motion } from "framer-motion";
import resDes from "../../../Assets/Images/responsive-design.png";
import editor from "../../../Assets/Images/code-editor.png";
import CreativeDev from "../../../Assets/Images/creative-dev.png";
import SectionHeading from "../../SectionHeading";
import { fadeUp, revealOnce, stagger } from "../../motion";
import "../../css/Empower.css";

const FEATURES = [
  {
    img: resDes,
    title: "Responsive Design",
    text: "Crafting engaging, adaptable interfaces that work beautifully on any device.",
  },
  {
    img: editor,
    title: "Clean Code",
    text: "Maintainable, well-structured code that scales with your product.",
  },
  {
    img: CreativeDev,
    title: "Creative Development",
    text: "Innovative techniques for stunning, intuitive user experiences.",
  },
];

const Empower = () => {
  return (
    <section className="section empower">
      <div className="container">
        <SectionHeading
          eyebrow="Let's collaborate"
          title="Empower your business with full-stack development"
          subtitle="A Lagos-based developer delivering exceptional software, backed by a versatile skill set across multiple development and IT domains."
        />

        <motion.div className="empower__grid" variants={stagger} {...revealOnce}>
          {FEATURES.map((feature) => (
            <motion.article
              key={feature.title}
              className="empower-card"
              variants={fadeUp}
            >
              <span className="empower-card__icon">
                <img src={feature.img} alt="" aria-hidden="true" loading="lazy" />
              </span>
              <h3>{feature.title}</h3>
              <p>{feature.text}</p>
            </motion.article>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Empower;
